module.exports = __webpack_public_path__ + "static/img/line.0f7914c7.svg";